import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

export const getAvailableMessengers = async websiteToken => {
  const urlData = endPoints.getAvailableMessengers(websiteToken);
  return API.get(urlData.url, { params: urlData.params });
};
